import { Auth } from 'aws-amplify';
import React from 'react';
import Avatar from 'react-avatar';
import { Container } from 'reactstrap';
import { useStateValue } from '../../State';
import "./TopBar.css";

// Vem do "version" do package.json (injetado por scripts/react-scripts.js)
const APP_VERSION = process.env.REACT_APP_VERSION;



const TopBar = () => {
    const [{ cognito }] = useStateValue();

    const handleLogout = async () => {
        await Auth.signOut()
            .then((data) => {
                console.log(data);
                alert("Logoff done")
                try { window.location.href = '/login'; } catch(e){}
            })
            .catch((err) => {
                console.log(err);
            });
    }

    return(
        <Container id="TopBar" fluid>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <img
                        src={`${process.env.PUBLIC_URL}/simemap-logo.png`}
                        alt="Simemap"
                        onError={(e) => { e.currentTarget.src = `${process.env.PUBLIC_URL}/logo512.png`; }}
                        style={{ height: 60, objectFit: 'contain' }}
                    />
                    <span style={{ fontSize: '1.25rem', fontWeight: 500, color: '#2c3e50' }}>Rastreamento</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <Avatar size={42} round={true} src={cognito.picture} alt='User Avatar' value={cognito.username?.substring(0, 1)?.toUpperCase()}/>
                    <span style={{ fontSize: '0.95rem', color: '#495057', fontWeight: 500 }}>{cognito.username}</span>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '2px' }}>
                    <button 
                        onClick={handleLogout}
                        style={{
                            background: 'transparent',
                            border: '1px solid #dee2e6',
                            borderRadius: '6px',
                            padding: '8px 20px',
                            fontSize: '0.95rem',
                            color: '#495057',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            fontWeight: 500
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.background = '#f8f9fa';
                            e.target.style.borderColor = '#adb5bd';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.background = 'transparent';
                            e.target.style.borderColor = '#dee2e6';
                        }}
                    >
                        Sair
                    </button>
                    {APP_VERSION && (
                        <span style={{ fontSize: '0.7rem', color: '#000' }}>v. {APP_VERSION}</span>
                    )}
                    </div>
                </div>
            </div>
        </Container>
    );    
};

export default TopBar;